import FreeModeBook from './FreeModeBook/FreeModeBook.store';
import Exercise from './Exercise/Exercise.store';

export default {
    namespaced: true,
    modules: {
        FreeModeBook,
        Exercise,
    },
};
